













// @ts-nocheck
// ^^^^^^^^^^^ Disabled TypeScript linter in this file because it doesn't understand Vue components
// which is not wrapped in Vue.extend(), and we can't use Vue.extend() in Sanity serializers
// because of how src/components/SanityBlockContent.vue initializes the serializers.

import { PropType } from 'vue';
import 'highlight.js/styles/atom-one-dark.css';
import { getTitleForLanguage } from '@/utils/codeSyntaxSupport';
import Devicon from './Devicon.vue';

interface Code {
  // The actual code block we want to show
  code: string;
  // The programming language
  language: string;
  // The filename for the code block
  filename: string;
}

export default {
  name: 'SanityCodeBlockSerializer',
  components: {
    Devicon,
  },
  props: {
    code: Object as PropType<Code>,
    filename: String,
  },
  computed: {
    codeblockFilename() {
      // The @sanity/code-input plugin has a withFilename option that will include a textfield
      // for entering the filename for a codeblock. That field is bugged in the current version of the plugin
      // (2.9.0 - The Sanity desk tool crashes when making new codeblocks with the error `cannot read filename of undefined`),
      // so we had to make our own filename field to fall back on.
      //
      // The this.code.filename will be set when/if `withFilename` is working as intended.
      // The this.filename field will be set if we're using our own workaround.
      //
      // The ideal solution would be to use this.code.filename and not use a custom workaround,
      // so this is considered a temporary fix and the usage of this.filename should be removed once fixed.
      if (this.code.filename) {
        return this.code.filename;
      }
      if (this.filename) {
        return this.filename;
      }
      return null;
    },
    languageDisplayText() {
      return getTitleForLanguage(this.code.language);
    },
  },
};
